import { Injectable } from '@angular/core';
import { User } from '../../constants/user-info';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserConfigService {

  userInfo: BehaviorSubject<User>;
  constructor() { 
    this.userInfo = new BehaviorSubject(null);
  }

  setUserInfo(userInfo: User){
    this.userInfo.next(userInfo);
  }
  getUserInfo(){
    return this.userInfo.asObservable();
  }

}
